/**
 * Build-time feature flags for the frontend.
 *
 * Flags are resolved at build time from `import.meta.env` (Vite). They are NOT a
 * runtime system (no settings UI, no API hydration, no per-user toggles). A flag
 * is enabled only when its env var is the exact string `'true'`; any other value
 * (unset, `'false'`, `'1'`, ...) leaves it OFF. Default-OFF keeps prod safe with
 * zero deploy change; srv-999 opts in via `VITE_FEATURE_MY_VIEW=true`.
 */

/** Minimal shape of the env object the flag helpers read. */
export interface FeatureFlagEnv {
    VITE_FEATURE_MY_VIEW?: string;

    /** Any other variable of the env object; the flag helpers ignore them. */
    [key: string]: unknown;
}

/**
 * Pure helper: "Meine Ansicht" is enabled only when the env var is exactly `'true'`.
 * Kept pure (env passed in) so it is trivially unit-testable in the node test env,
 * where `import.meta.env` cannot be stubbed cleanly.
 */
export function isMyViewEnabled(env: FeatureFlagEnv): boolean {
    return env.VITE_FEATURE_MY_VIEW === 'true';
}

/** Resolved build-time flags consumed by the app (route + nav gating). */
export const FEATURE_FLAGS = {
    myView: isMyViewEnabled(import.meta.env),
} as const;
